module.exports = __webpack_public_path__ + "src/assets/individualImages/honeyBeeWorkerSkinCat.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/honeyBeeWorkerSkinCat.png
// module id = ./src/assets/individualImages/honeyBeeWorkerSkinCat.png
// module chunks = 0